import UserScreen from "app/screens/userRoles/UserScreen";

export default function UsersPage() {
  return <UserScreen />;
}
